// Route templates keep record ids out of analytics (spec D5): a path is sent
// as "/workspace/projects/:id", never with the real id, a query or a hash.

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
// Long opaque tokens (ULIDs, hex ids). Requiring a digit keeps long words
// like "organization" intact.
const OPAQUE = /^(?=.*\d)[A-Za-z0-9_]{16,}$/;

function looksLikeId(segment: string): boolean {
  return /^\d+$/.test(segment) || UUID.test(segment) || OPAQUE.test(segment);
}

export function routeTemplate(pathname: string): string {
  const path = pathname.split(/[?#]/, 1)[0];
  const segments = path.split("/").filter(Boolean).map((s) => (looksLikeId(s) ? ":id" : s));
  return `/${segments.join("/")}`;
}

/** The page area a workspace route belongs to, used as its outermost tag scope (spec D8). */
export function areaForPath(pathname: string): string | null {
  const [root, page] = routeTemplate(pathname).split("/").filter(Boolean);
  if (root !== "workspace") return null;
  return page ? page.replace(/-/g, "_") : "chat";
}
